import * as React from 'react';
import { Medal, MedalImg, MedalValue, MedalStars } from './medal';
import medalImg from './img/medal.svg';
import medalPrimaryImg from './img/medalPrimary.svg';
import medalSuccessImg from './img/medalSuccess.svg';
import medalWarningImg from './img/medalWarning.svg';
import medalDangerImg from './img/medalDanger.svg';
import medalGoldImg from './img/medalGold.svg';
import goldStars from './img/gold-stars.svg';
import medalMore from './img/more-medal.svg';

const medalImages = {
  default: medalImg,
  primary: medalPrimaryImg,
  success: medalSuccessImg,
  warning: medalWarningImg,
  danger: medalDangerImg,
  gold: medalGoldImg,
  more: medalMore
};

export const MedalContainer = React.forwardRef(({ value, size, src, ...props }, ref) => {
  const srcImg = medalImages[src] || medalImages.default;

  return (
    <Medal
      ref={ref}
      size={size}
      {...props}
    >
      <MedalImg
        src={srcImg}
        alt="medalha"
      />
      {value !== '0' && <MedalValue>{value}</MedalValue>}
      {src === 'gold' && (
        <MedalStars
          src={goldStars}
          alt="estrelas"
        />
      )}
    </Medal>
  );
});
MedalContainer.displayName = 'MedalContainer';
